import React, { useState, useEffect } from 'react';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import TradingViewLiveChart from '../../charts/lightweightcharts/TradingViewLiveChart';
import AskLiveChart from '../../components/ai/AskLiveChart';
import AskChartTopicsLessons from '../../components/ai/AskChartTopicsLessons';

// const chartTopics = [
//   'What is price action?',
//   'What are support and resistance levels?',
//   'What is a candlestick and how do I read it?',
//   'What is a trend line and how is it used?',
//   'What is a bullish vs bearish market?',
//   'What is volume and why does it matter?',
//   'How can I spot a breakout or breakdown?',
//   'What timeframe should I use to analyze BTCUSD?',
//   'What is RSI and how is it used?',
//   'What is MACD and how to interpret it?',
//   'What are chart patterns like head and shoulders?',
//   'What is a double top or bottom pattern?',
//   'How do I read moving averages?',
//   'What is market sentiment and how to gauge it?',
//   'How can I tell if a trend is reversing?',
//   'What’s the difference between technical and fundamental analysis?',
//   'What does high volume at key levels mean?',
//   'What is a fakeout and how to avoid it?',
//   'What is divergence and how to spot it?',
//   'What are psychological levels in trading?' 
// ];

const Insights = () => {
  const [symbol, setSymbol] = useState('');
  const [showAskChartModal, setShowAskChartModal] = useState(false);
  const [chartContextPrompt, setChartContextPrompt] = useState('');
  const [validSymbol, setValidSymbol] = useState(true);


  const [showAskButton, setShowAskButton] = useState(false);


  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
  
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);




  const handleAskChart = () => {
    setChartContextPrompt(`User selected ${symbol}. Show key technical insight for current 1D setup.`);
    setShowAskChartModal(true);
  };

  const handleTopicClick = (topic) => {
    alert(` Upgrade to FinTorro Pro to unlock full chart AI access!\n\nUpgrade to FinTorro Pro and get:\n• Unlimited Lessons & Practice\n• Learn with AI\n• 10,000+ Interactive Lessons\n• Crypto, Forex, Stocks & More\n• Join Challenges & Earn Rewards`);
  };

  // useEffect(() => {
  //   if (symbol.trim().length >= 3) {
  //     setValidSymbol(true);
  //   } else {
  //     setValidSymbol(false);
  //   }
  // }, [symbol]);

  useEffect(() => {
    const trimmedSymbol = symbol.trim();
    const isValid = trimmedSymbol.length >= 3;
  
    setValidSymbol(isValid);
    setShowAskButton(false); // Reset

  
    // Debounce logic: wait 1.2 seconds after last keystroke
    const debounceTimeout = setTimeout(() => {
      setShowAskButton(isValid); // Only after typing stops
      const logSymbolSearch = async () => {
        try {
          const db = getFirestore();
          const auth = getAuth();
          const user = auth.currentUser;
          const userId = user?.uid || 'anonymous';
  
          await addDoc(collection(db, 'user_ask_the_chart_symbols'), {
            instrument: trimmedSymbol,
            date: serverTimestamp(),
            userid: userId,
            isvalid: isValid ? 'yes' : 'no',
            charttype: 'live',
            timeframe: '1D',
            channel: 'web',
          });
        } catch (err) {
          console.error('⚠️ Failed to log user_ask_the_chart_symbols:', err);
        }
      };
  
      if (trimmedSymbol) {
        logSymbolSearch();
      }
    }, 1200); // Wait for 1.2s of no typing
  
    return () => clearTimeout(debounceTimeout); // Clear if user keeps typing
  }, [symbol]);
  

  return (
    <div
      style={{
        padding: '40px',
        backgroundColor: '#232830',
        minHeight: '100vh',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontFamily: 'Nunito Sans, sans-serif',
      }}
    >
      {/* <h1 style={{ color: '#FF7C24', marginBottom: '5px', fontSize: '32px' }}>📈✨ Ask the Chart</h1>
      <p style={{ fontSize: '18px', color: '#ffffff', marginBottom: '30px' }}>
        Enter a market symbol and press Ask AI to reveal insights 🧠📊
      </p> */}

       <h1 style={{ color: '#FF7C24', marginBottom: '5px', fontSize: '32px' }}>📈✨ Test Your Strategy with AI</h1>
      <p style={{ fontSize: '18px', color: '#ffffff', marginBottom: '30px' }}>
        Enter a market symbol and press Research to reveal insights 🧠📊
      </p>

      <form
        style={{
          marginBottom: '20px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <input
          type="text"
          title="Type a trading symbol like BTCUSD, AAPL, EURUSD"
          value={symbol}
          onChange={(e) => setSymbol(e.target.value.toUpperCase())}
          placeholder="Enter symbol e.g. BTCUSD, AAPL"
          style={{
            padding: '12px',
            fontSize: '18px',
            width: '300px',
            borderRadius: '10px',
            marginRight: '10px',
            marginBottom: '10px',
            backgroundColor: '#ffffff',
            color: '#232830',
            border: '2px solid #FF7C24',
            outline: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        />
       {symbol.length > 0 && (
  <button
    type="button"
    onClick={handleAskChart}
    disabled={!validSymbol || !showAskButton}
    title={!showAskButton ? "Enter a valid symbol (e.g. BTCUSD) and wait a second..." : "Get AI-powered chart insights"}
    style={{
      backgroundColor: showAskButton ? '#FF7C24' : '#888888',
      opacity: showAskButton ? 1 : 0.6,
      padding: '12px 22px',
      fontSize: '18px',
      color: '#fff',
      border: 'none',
      borderRadius: '10px',
      marginBottom: '10px',
      cursor: showAskButton ? 'pointer' : 'not-allowed',
      fontWeight: 'bold',
      transition: 'all 0.3s ease',
    }}
    onMouseOver={(e) => {
      if (showAskButton) e.currentTarget.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      if (showAskButton) e.currentTarget.style.transform = 'scale(1)';
    }}
  >
    {/* 🧠 {showAskButton ? 'Ask AI' : '...'} */}
    🧠 {showAskButton ? 'Test Strategy' : '...'}
  </button>
)}
      </form>

      <div style={{ fontSize: '14px', marginBottom: '20px', textAlign: 'center' }}>
        <h6 style={{ color: '#FF7C24', fontWeight: 'bold' }}>
          ⚡ Tip: <span style={{ color: '#ffffff', fontWeight: 'normal' }}>Try symbols like <code>BTCUSD</code>, <code>EURUSD</code>, <code>TSLA</code>, <code>NVDA</code> </span>
        </h6>
      </div>

      {/* {validSymbol && (
        <div style={{ marginTop: '20px', width: '100%', maxWidth: '960px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', borderRadius: '10px' }}>
          <TradingViewLiveChart symbol={symbol} />
          <AskChartTopicsLessons />
        </div>
      )} */}

{validSymbol && (
  <>
    <div
      style={{
        marginTop: '20px',
        width: '100%',
        maxWidth: '960px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        borderRadius: '10px',
      }}
    >
      <TradingViewLiveChart symbol={symbol} />
    </div>

    {/* Section Divider */}
    <div
      style={{
        marginTop: '40px',
        marginBottom: '20px',
        width: '100%',
        maxWidth: '960px',
        borderTop: '2px dashed #FF7C24',
        paddingTop: '30px',
      }}
    >
      <h4 style={{ color: '#FF7C24', fontWeight: 'bold', marginBottom: '16px' }}>
        🧠 Lessons to Learn
      </h4>
      <AskChartTopicsLessons />
    </div>
  </>
)}


      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: '30px',
        gap: '15px',
        maxWidth: '960px'
      }}>
        {/* {chartTopics.map((topic, index) => (
          <div
            key={index}
            onClick={() => handleTopicClick(topic)}
            style={{
              backgroundColor: '#fff',
              color: '#232830',
              padding: '12px 16px',
              borderRadius: '12px',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: '500',
              minWidth: '260px',
              textAlign: 'center',
              boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
              transition: 'transform 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            {topic}
          </div>
        ))} */}
      </div>

      <AskLiveChart
        show={showAskChartModal}
        onClose={() => setShowAskChartModal(false)}
        instrument={symbol}
        charttype="live"
        timeframe="1D"
        chartContextPrompt={chartContextPrompt}
      />




      
    </div>
  );
};

export default Insights;



// import React, { useState, useEffect } from 'react';
// import TradingViewLiveChart from '../../charts/lightweightcharts/TradingViewLiveChart';
// import AskLiveChart from '../../components/ai/AskLiveChart';

// const Insights = () => {
//   const [symbol, setSymbol] = useState('BTCUSD');
//   const [showAskChartModal, setShowAskChartModal] = useState(false);
//   const [chartContextPrompt, setChartContextPrompt] = useState('');
//   const [validSymbol, setValidSymbol] = useState(true);

//   const handleAskChart = () => {
//     setChartContextPrompt(`User selected ${symbol}. Show key technical insight for current 1D setup.`);
//     setShowAskChartModal(true);
//   };

//   useEffect(() => {
//     if (symbol.trim().length >= 3) {
//       setValidSymbol(true);
//     } else {
//       setValidSymbol(false);
//     }
//   }, [symbol]);

//   return (
//     <div
//       style={{
//         padding: '40px',
//         backgroundColor: '#232830',
//         minHeight: '100vh',
//         color: '#fff',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         fontFamily: 'Nunito Sans, sans-serif',
//       }}
//     >
//       <h1 style={{ color: '#FF7C24', marginBottom: '5px', fontSize: '32px' }}>📈✨ Find Market Sentiment</h1>
//       <p style={{ fontSize: '18px', color: '#ffffff', marginBottom: '30px' }}>
//         Enter a market symbol and press Ask AI to reveal insights 🧠📊
//       </p>

//       <form
//         style={{
//           marginBottom: '20px',
//           display: 'flex',
//           flexDirection: 'row',
//           alignItems: 'center',
//           justifyContent: 'center',
//           flexWrap: 'wrap',
//         }}
//       >
//         <input
//           type="text"
//           value={symbol}
//           onChange={(e) => setSymbol(e.target.value.toUpperCase())}
//           placeholder="Enter symbol e.g. BTCUSD, AAPL"
//           style={{
//             padding: '12px',
//             fontSize: '18px',
//             width: '300px',
//             borderRadius: '10px',
//             marginRight: '10px',
//             marginBottom: '10px',
//             backgroundColor: '#ffffff',
//             color: '#232830',
//             border: '2px solid #FF7C24',
//             outline: 'none',
//             boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//           }}
//         />
//         {validSymbol && (
//           <button
//             type="button"
//             onClick={handleAskChart}
//             style={{
//               backgroundColor: '#FF7C24',
//               padding: '12px 22px',
//               fontSize: '18px',
//               color: '#fff',
//               border: 'none',
//               borderRadius: '10px',
//               marginBottom: '10px',
//               cursor: 'pointer',
//               fontWeight: 'bold',
//               transition: 'transform 0.2s ease',
//             }}
//             onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
//             onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//           >
//             🔍 Ask AI
//           </button>
//         )}
//       </form>

//       <div style={{ fontSize: '14px', marginBottom: '20px', textAlign: 'center' }}>
//         <h6 style={{ color: '#FF7C24', fontWeight: 'bold' }}>
//           ⚡ Tip: <span style={{ color: '#ffffff', fontWeight: 'normal' }}>Try symbols like <code>BTCUSD</code>, <code>AAPL</code>, <code>TSLA</code></span>
//         </h6>
//       </div>

//       {validSymbol && (
//         <div style={{ marginTop: '20px', width: '100%', maxWidth: '960px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', borderRadius: '10px' }}>
//           <TradingViewLiveChart symbol={symbol} />
//         </div>
//       )}

//       <AskLiveChart
//         show={showAskChartModal}
//         onClose={() => setShowAskChartModal(false)}
//         instrument={symbol}
//         charttype="live"
//         timeframe="1D"
//         chartContextPrompt={chartContextPrompt}
//       />
//     </div>
//   );
// };

// export default Insights;
